export default class Cookie {
    constructor(name, val, days) {
        this.name = name;
        this.val = val;
        this.days = parseInt(days);
    }

    init() {
        if (!this.name || !this.val || !this.days) {
            return false;
        }
    }

    checkCookieExist(name) {
        var match = document.cookie.match(RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
        return match ? match[1] : false;
    }

    createCookie() {
        if (navigator.cookieEnabled) {
            const cookieName = encodeURIComponent(this.name);
            const cookieVal = encodeURIComponent(this.val);
            let cookieText = cookieName + '=' + cookieVal;

            const data = new Date();
            data.setTime(data.getTime() + (this.days * 24 * 60 * 60 * 1000));
            cookieText += '; expires=' + data.toGMTString() + ';domain=' + window.location.host + ';path=/';

            document.cookie = cookieText;
        }
    }

}
